import React from 'react';
import { Badge } from '@chakra-ui/react';

const variants = {
  pending: {
    bg: 'bg.amberTint',
    color: 'text.primary',
    borderColor: 'utkarsh.amber',
  },
  verified: {
    bg: 'green.50',
    color: 'status.success',
    borderColor: 'status.success',
  },
  error: {
    bg: 'bg.errorTint',
    color: 'status.error',
    borderColor: 'status.error',
  },
  warning: {
    bg: 'bg.secondaryTint',
    color: 'status.warning',
    borderColor: 'status.warning',
  },
  info: {
    bg: 'bg.amberTint',
    color: 'status.info',
    borderColor: 'status.info',
  },
  neutral: {
    bg: 'bg.input',
    color: 'text.secondary',
    borderColor: 'border.subtle',
  },
};

export function StatusBadge({ status = 'neutral', size = 'md', children, ...props }) {
  const style = variants[status] || variants.neutral;
  const compact = size === 'sm';
  return (
    <Badge
      bg={style.bg}
      color={style.color}
      border="1px solid"
      borderColor={style.borderColor}
      fontSize={compact ? '10px' : undefined}
      fontWeight={compact ? '600' : undefined}
      px={compact ? 1.5 : undefined}
      py={compact ? 0.5 : undefined}
      lineHeight={compact ? '1.2' : undefined}
      textTransform={compact ? 'none' : undefined}
      borderRadius={compact ? 'sm' : undefined}
      _dark={{
        bg:
          status === 'pending'
            ? 'utkarsh.darkAmberTint'
            : status === 'verified'
              ? 'whiteAlpha.100'
              : status === 'error'
                ? 'whiteAlpha.100'
                : 'whiteAlpha.100',
      }}
      {...props}
    >
      {children}
    </Badge>
  );
}
